<template>
  <v-container>
    <v-card class="d-flex justify-center mb-6" flat>
      <v-card class="pa-5" flat>
        <v-row justify="center" align="center">
          <v-col md="6">
            <v-card class="elevation-0">
              <v-img height="30%" :src="backgroundUrlToUse"></v-img>
            </v-card>
          </v-col>
          <v-col md="6">
            <v-card class="elevation-0">
              <v-card-title>
                <h1 class="text-h1">{{code}}</h1>
              </v-card-title>
              <v-card-text>
                <p class="text-h4">{{message}}</p>
                <slot></slot>
              </v-card-text>
              <v-card-actions>
                <slot name="actions"></slot>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
export default {

  name: 'Error',

  props: {
    code: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    backgroundUrl: {
      type: String
    }
  },

  methods: {
    back() {
      this.$router.back();
    }
  },

  data: () => ({
    backgroundUrls: [
      'ANGER.png',
      'DISGUST.png',
      'SADNESS.png',
    ]
  }),

  computed: {
    backgroundUrlToUse() {
      if(this.backgroundUrl) {
        return this.backgroundUrl
      }
      const random = Math.floor(Math.random() * this.backgroundUrls.length)
      return require('../../assets/errors/' + this.backgroundUrls[random]);
    }
  }

}
</script>